import React from 'react'
import { ThemeSwitcherProvider } from 'react-css-theme-switcher'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { APP_NAME, THEME_CONFIG } from './configs/AppConfig'
import history from './history'
import './lang'
import Layouts from './layouts'
import store from './store'

const themes = {
    dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
    light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
}



// const environment = process.env.NODE_ENV

// if (environment !== 'development') {
//     mockServer({ environment })
// }

function App() {
    React.useEffect(() => {
        document.title = APP_NAME;
      }, []);
    return (
        <div className="App">
            <Provider store={store}>
                <BrowserRouter history={history}>
                    <ThemeSwitcherProvider
                        themeMap={themes}
                        defaultTheme={THEME_CONFIG.currentTheme}
                        insertionPoint="styles-insertion-point">
                        <Layouts />
                    </ThemeSwitcherProvider>
                </BrowserRouter>
            </Provider>
        </div>
    )
}

export default App
